import { SectionContainer } from 'components/DetailsView/Section';
import {
    GetManualSupplyOrdersQuery,
    GetManualSupplyOrderSupplierProductsStockVariationQuery,
} from 'data/__generated__';
import { ProductsInfoTable } from './ProductsInfoTable';

export const ProductsInfoSection = ({
    manualSupplyOrders,
    stockVariationData,
    stockVariationLoading,
    stockVariationError,
    updateForecastsLoading,
}: {
    manualSupplyOrders: GetManualSupplyOrdersQuery['manualSupplyOrders'];
    stockVariationData?: GetManualSupplyOrderSupplierProductsStockVariationQuery['manualSupplyOrderSupplierProductsStockVariation'];
    stockVariationLoading?: boolean;
    stockVariationError?: Error | null;
    updateForecastsLoading?: boolean;
}) => {
    return (
        <SectionContainer
            title={`Produits (${manualSupplyOrders.flatMap((supplyOrder) => supplyOrder.products).length})`}
            isInitiallyOpen
        >
            <ProductsInfoTable
                supplyOrders={manualSupplyOrders}
                stockVariationData={stockVariationData}
                stockVariationLoading={stockVariationLoading}
                stockVariationError={stockVariationError}
                updateForecastsLoading={updateForecastsLoading}
            />
        </SectionContainer>
    );
};
